import { useCallback, useRef, useState } from "react";

export default function useEstadoSalvamento() {
  const [salvandoCadastro, setSalvandoCadastro] = useState(false);
  const salvandoRef = useRef(false);

  const executarSalvamento = useCallback(async (tarefa) => {
    if (salvandoRef.current) return undefined;

    salvandoRef.current = true;
    setSalvandoCadastro(true);

    try {
      return await tarefa();
    } finally {
      salvandoRef.current = false;
      setSalvandoCadastro(false);
    }
  }, []);

  return { salvandoCadastro, executarSalvamento };
}
